import React, { useEffect, useState, useRef } from 'react';
import {
    Building, User, MapPin, Globe, Mail, Phone, MessageSquare,
    MessageCircle, StickyNote, CheckSquare, Calendar, DollarSign,
    Upload, Bell, MoreHorizontal, ChevronRight, Search,
    Info, ExternalLink, X, Send, UserCheck, Users, Clock, ArrowLeft, Mic2, BadgePercent, FileText, CheckCircle, Paperclip
} from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";
import { GoGitBranch } from "react-icons/go";
import API_ENDPOINTS from '../../../config/apiEndpoints';
import Alert from '../../../common/Alerts/Alert';
import { getSession } from '../../../getSession';
import './EnquiryActionOperation.css';

const EnquiryActionOperation = ({ entity, mode, onBack, onSuccess, enableTemplatePreview = false, selectedEnquiries, isAllSelectedAcrossPages }) => {
    const [currentMode, setCurrentMode] = useState(mode);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { userId: SESSION_USER_ID, TokenId: SESSION_TOKEN, parentId: SESSION_PARENT_ID } = getSession();
    const TOKEN = SESSION_TOKEN || API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const DEFAULT_USER_ID = SESSION_USER_ID || localStorage.getItem('userId') || '34594';
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');

    // Custom Endpoints
    const CRM_SERVICE_BASE = "https://wcfkit19.azurewebsites.net/UserCRMCampaign/Service/CRMService.asmx";
    const SEND_EMAIL_EXT = `${CRM_SERVICE_BASE}/SendEmail`;
    const SEND_SMS_EXT = `${CRM_SERVICE_BASE}/SendSms`;
    const LOCAL_BASE_URL = (process.env.REACT_APP_LOCAL_DEVELOPMENT_URL || '').replace(/\/$/, '');
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    



    // Shared Endpoints from LeadActionOperation
    const FROM_MAIL_IDS = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_FROM_MAIL_ID}`;
    const Template_for_main = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_TEMPLATE_FOR_MAIL}`;
    const GET_MAIL_SMS_DLT_ACCOUNT = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_MAIL_SMS_DLT_ACCOUNT}`;
    const SENDERID = `${API_BASE1}${API_ENDPOINTS.APPOINTMENTS.GET_SENDER_IDFOR_SMS}`;
    const GET_MAIL_SUBJECT_FROM_TEMPLATE = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.GET_MAIL_SUBJECT_FROM_TEMPLATE}`;
    const Send_voice = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_VOICE}`;

    const GET_ENQUIRY_LIST = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.ENQUIRY_DETAILS_LIST}`;
    const add_voice = `${NEWV3_BASE_URL}${API_ENDPOINTS.COMMON.SEND_VOICE_NEW}`;
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const Is_Register_for_Whatsapp = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.IS_REGISTER_FOR_WHATSAPP}`.trim();
    const Whatsapp_Template = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.WHATSAPP_TEMPLATE}`;
    const SEND_TEMPLATE = `${NEW_BASE_URL}/${API_ENDPOINTS.APPOINTMENTS.SEND_WHATSAPP_TEMPLATE}`;

    const API_BASE_OLD = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const ADD_PHYSICAL_APPOINTMENT = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.ADD_PHYSICAL_APPOINTMENT}`;
    const SALES_ACTIVITY_TYPE_URL = `${NEW_BASE_URL}${API_ENDPOINTS.TASKS.GET_SALES_ACTIVITY_TYPE}`;
    const USER_HIERARCHY_URL = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
    const TAG_LIST_FILTER = `${NEW_BASE_URL}/UserCRM/GetAllSegmentList`;
    const ADD_REMOVE_TAGS = `${NEW_BASE_URL}${API_ENDPOINTS.ENQUIRIES.ADD_REMOVE_TAGS}`;
    const FOLLOWUP_STATUS_URL = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.FOLLOWUPSTATUS_LIST}`;
    const SAVE_MASS_FOLLOWUP = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_MASS_FOLLOWUP}`;
    const PRODUCT_SUGGESTION = `${NEW_BASE_URL}/${API_ENDPOINTS.APPOINTMENTS.PRODUCT_SUGGESTION_FOR_FOLLOWUP}`;
    const Get_Associate_Mobile_No = `${NEW_BASE_URL}${API_ENDPOINTS.ENQUIRIES.GET_ASSOCIATE_MOBILE_NO_WHATSAPP}`;
      const Get_Associate_Wrapper = `${NEW_BASE_URL}${API_ENDPOINTS.ENQUIRIES.GET_ASSOCIATE_WRAPPER}`;

    const [sendMailData, setSendMailData] = useState({
        ChooseEmails: entity.Email ? [entity.Email] : [],
        Account: '',
        From: '',
        ReplyTo: '',
        MailMode: 'template',
        Subject: '',
        TemplateId: '',
        Body: ''
    });

    const [sendSmsData, setSendSmsData] = useState({
        ChooseNumbers: entity.MobileNo ? [entity.MobileNo] : [],
        Account: '',
        SenderId: '',
        TemplateId: '',
        Message: '',
        IsUnicode: false,
        SmsType: 'template'
    });

    const [sendVoiceData, setSendVoiceData] = useState({
        ChooseNumbers: entity.MobileNo ? [entity.MobileNo] : [],
        DnidNo: '',
        AppFlow: '',
        Route: 'trans',
        Duration: '30'
    });

    const [appointmentData, setAppointmentData] = useState({
        Title: `Appointment_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
        ActivityType: '505',
        Description: '',
        Remarks: '',
        StartDate: new Date().toISOString().split('T')[0],
        StartTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        EndDate: new Date().toISOString().split('T')[0],
        EndTime: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Where: '',
        CompleteAddress: '',
        Owner: DEFAULT_USER_ID,
        Collaborators: []
    });

    const [mailAccounts, setMailAccounts] = useState([]);
    const [fromMailOptions, setFromMailOptions] = useState([]);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [smsAccounts, setSmsAccounts] = useState([]);
    const [smsSenderIds, setSmsSenderIds] = useState([]);
    const [smsTemplates, setSmsTemplates] = useState([]);
    const [dniNumbers, setDniNumbers] = useState([]);
    const [appFlows, setAppFlows] = useState([]);
    const [salesActivityOptions, setSalesActivityOptions] = useState([]);
    const [collaboratorOptions, setCollaboratorOptions] = useState([]);
    const [scriptsLoaded, setScriptsLoaded] = useState(false);
    const isValidValue = (val) => {
        if (!val) return false;
        const placeholders = ['-', '0', 'N/A', 'n/a', 'NA', 'na', 'null', 'undefined'];
        return !placeholders.includes(String(val).trim());
    };

    const [availableEmails, setAvailableEmails] = useState(isValidValue(entity.Email) ? [entity.Email] : []);
    const [availableNumbers, setAvailableNumbers] = useState(isValidValue(entity.MobileNo) ? [entity.MobileNo] : []);
    const [whatsappData, setWhatsappData] = useState({
        TemplateId: '',
        Message: '',
        IsRegistered: false,
        SelectedTemplate: null,
        ChannelProfileId: ''
    });
    const [whatsappTemplates, setWhatsappTemplates] = useState([]);
    const [isCheckingWhatsapp, setIsCheckingWhatsapp] = useState(false);
    const [associateMobileList, setAssociateMobileList] = useState([]);
    const [selectedAssociate, setSelectedAssociate] = useState(null);
    const [showAssociateView, setShowAssociateView] = useState(false);
    const [isAssociating, setIsAssociating] = useState(false);

    // Tagging state
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState('');
    const [isCustomTag, setIsCustomTag] = useState(false);
    const [isScheduled, setIsScheduled] = useState(false);
    const [scheduleDateTime, setScheduleDateTime] = useState(() => {
        const now = new Date();
        const offset = now.getTimezoneOffset() * 60000;
        return new Date(now - offset).toISOString().slice(0, 16);
    });
    const [isLoading, setIsLoading] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ 
        show: false, 
        type: 'success', 
        title: '', 
        message: '', 
        confirmText: 'OK',
        onConfirm: null,
        onCancel: null 
    });

    // Followup state
    const [followupStatusOptions, setFollowupStatusOptions] = useState([]);
    const [followupData, setFollowupData] = useState({
        FollowupStatus: '',
        AssignTo: DEFAULT_USER_ID,
        NextStatusDate: new Date().toISOString().split('T')[0],
        NextStatusTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        AmountPaid: '',
        Remarks: '',
        Products: '',
        IsReassign: false,
        OnSchedule: false,
        ScheduleDateTime: new Date().toISOString().slice(0, 16)
    });

    // Product Suggestion States
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);

    // Debounced Product Search
    useEffect(() => {
        const fetchProducts = async () => {
            if (productSearchTerm.trim().length < 2) {
                setSuggestedProducts([]);
                setShowProductDropdown(false);
                return;
            }
            try {
                const response = await fetch(PRODUCT_SUGGESTION, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: TOKEN,
                        Details: { Term: productSearchTerm, UserId: Number(DEFAULT_USER_ID) }
                    })
                });
                if (response.ok) {
                    const data = await response.json();
                    setSuggestedProducts(data.Details || []);
                    setShowProductDropdown(true);
                }
            } catch (err) {
                console.error("Error fetching product suggestions:", err);
            }
        };
        const timer = setTimeout(fetchProducts, 500);
        return () => clearTimeout(timer);
    }, [productSearchTerm]);

    const handleSelectProduct = (product) => {
        setFollowupData(prev => {
            const currentProducts = prev.Products ? prev.Products.split(',').map(p => p.trim()).filter(Boolean) : [];
            if (!currentProducts.includes(product.Name)) {
                const newList = [...currentProducts, product.Name];
                return { ...prev, Products: newList.join(', ') };
            }
            return prev;
        });
        setProductSearchTerm('');
        setShowProductDropdown(false);
    };

    const handleRemoveProduct = (productName) => {
        setFollowupData(prev => {
            const currentProducts = prev.Products ? prev.Products.split(',').map(p => p.trim()).filter(Boolean) : [];
            const newList = currentProducts.filter(p => p !== productName);
            return { ...prev, Products: newList.join(', ') };
        });
    };

    const whereInputRef = useRef(null);
    const googleAutocompleteRef = useRef(null);

    useEffect(() => {
        setCurrentMode(mode);
    }, [mode]);

    useEffect(() => {
        if (currentMode === 'mail' || currentMode === 'send-mail') {
            fetchMailAccounts();
            fetchFromMailIds();
            fetchMailTemplates();
        } else if (currentMode === 'sms' || currentMode === 'send-sms') {
            fetchSmsAccounts();
            fetchSmsSenderIds();
            fetchSmsTemplates();
        } else if (currentMode === 'voice' || currentMode === 'send-voice') {
            fetchDniNumbers();
            fetchAppFlows();
        } else if (currentMode === 'appointment' || currentMode === 'add-appointment') {
            fetchSalesActivityTypes();
            fetchCollaborators();
            initGoogleMaps();
        } else if (currentMode === 'whatsapp' || currentMode === 'send-whatsapp') {
            checkWhatsAppRegistration();
            fetchWhatsAppTemplates();
        } else if (currentMode === 'add_tag' || currentMode === 'remove_tag') {
            fetchTags();
        } else if (currentMode === 'followup') {
            fetchFollowupStatuses();
            fetchCollaborators();
        }
    }, [currentMode]);

    useEffect(() => {
        let autocompleteListener = null;
        if (scriptsLoaded && (currentMode === 'appointment' || currentMode === 'add-appointment')) {
            const initAutocomplete = () => {
                if (!whereInputRef.current || !window.google?.maps?.places) return false;
                googleAutocompleteRef.current = new window.google.maps.places.Autocomplete(whereInputRef.current, { types: ['geocode', 'establishment'] });
                autocompleteListener = googleAutocompleteRef.current.addListener('place_changed', () => {
                    const place = googleAutocompleteRef.current.getPlace();
                    const address = place.formatted_address || place.name;
                    setAppointmentData(prev => ({ ...prev, Where: address, Latitude: place.geometry?.location?.lat() || '', Longitude: place.geometry?.location?.lng() || '' }));
                });
                return true;
            };
            if (!initAutocomplete()) {
                const pollInterval = setInterval(() => { if (initAutocomplete()) clearInterval(pollInterval); }, 100);
                setTimeout(() => clearInterval(pollInterval), 5000);
            }
        }
        return () => { if (autocompleteListener && window.google?.maps?.event) { window.google.maps.event.removeListener(autocompleteListener); } };
    }, [scriptsLoaded, currentMode]);

    useEffect(() => {
        if (entity.enquiryId) {
            fetchEnquiryDetails();
        }
    }, [entity.enquiryId]);

    const fetchEnquiryDetails = async () => {
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    txt_search: "",
                    parent_id: SESSION_PARENT_ID || '0',
                    user_id: DEFAULT_USER_ID,
                    filter_text: `EnquiryId = ${entity.enquiryId}`,
                    order_str: "",
                    srno: "1",
                    enno: "1",
                    ue_query: ""
                }
            };
            const response = await fetch(GET_ENQUIRY_LIST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details?.[0];
                if (data) {
                    const email = data.EmailID || data.EmailID3 || '';
                    const mobile = data.MobileNo || data.MobileNo3 || '';

                    if (isValidValue(email)) {
                        setAvailableEmails(prev => Array.from(new Set([...prev.filter(isValidValue), email])));
                        setSendMailData(prev => ({
                            ...prev,
                            ChooseEmails: prev.ChooseEmails.filter(isValidValue).length === 0 ? [email] : prev.ChooseEmails.filter(isValidValue)
                        }));
                    }
                    if (isValidValue(mobile)) {
                        setAvailableNumbers(prev => Array.from(new Set([...prev.filter(isValidValue), mobile])));
                        setSendSmsData(prev => ({
                            ...prev,
                            ChooseNumbers: prev.ChooseNumbers.filter(isValidValue).length === 0 ? [mobile] : prev.ChooseNumbers.filter(isValidValue)
                        }));
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching enquiry details:", error);
        }
    };

    const fetchMailAccounts = async () => {
        try {
            const payload = {
                Token: TOKEN,
                LoggedUserId: DEFAULT_USER_ID,
                Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), isSMS: false }
            };
            const response = await fetch(GET_MAIL_SMS_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setMailAccounts(finalAccounts);
                if (finalAccounts.length > 0) setSendMailData(prev => ({ ...prev, Account: finalAccounts[0].AccountId || finalAccounts[0].Code }));
            }
        } catch (error) { console.error("Error fetching Mail accounts:", error); }
    };

    const fetchFromMailIds = async () => {
        try {
            const payload = { Token: TOKEN, Details: { UserId: Number(DEFAULT_USER_ID) } };
            const response = await fetch(FROM_MAIL_IDS, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                if (Array.isArray(data)) {
                    setFromMailOptions(data);
                    if (data.length > 0) {
                        setSendMailData(prev => ({ ...prev, From: data[0].Value, ReplyTo: data[0].Value }));
                    }
                }
            }
        } catch (error) { console.error("Error fetching from mail IDs:", error); }
    };

    const fetchMailTemplates = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), isSMS: 0, isMail: 1 } };
            const response = await fetch(Template_for_main, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsedData = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsedData = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsedData)) {
                    setMailTemplates(parsedData.map(item => ({
                        ...item,
                        MailTemplateId: item.MailTemplateId ?? item.Id,
                        MailTemplateName: item.MailTemplateName ?? item.Name,
                        MailTemplateContent: item.MailTemplateContent ?? item.Content,
                        MailTemplateSubject: item.MailTemplateSubject ?? item.Subject ?? ""
                    })));
                }
            }
        } catch (error) { console.error("Error fetching mail templates:", error); }
    };

    const fetchMailSubject = async (templateId) => {
        if (!templateId) return;
        try {
            const payload = {
                Token: TOKEN.toString(),
                Details: { TemplateId: templateId }
            };
            const response = await fetch(GET_MAIL_SUBJECT_FROM_TEMPLATE, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            const subject = result?.Details || result?.d || result?.data || "";
            if (subject) {
                setSendMailData(prev => ({ ...prev, Subject: subject }));
            }
        } catch (error) { console.error("Error fetching mail subject:", error); }
    };

    const fetchSmsAccounts = async () => {
        try {
            const payload = {
                Token: TOKEN,
                LoggedUserId: DEFAULT_USER_ID,
                Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), isSMS: true }
            };
            const response = await fetch(GET_MAIL_SMS_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setSmsAccounts(finalAccounts);
                if (finalAccounts.length > 0) setSendSmsData(prev => ({ ...prev, Account: finalAccounts[0].AccountId || finalAccounts[0].Code }));
            }
        } catch (error) { console.error("Error fetching SMS accounts:", error); }
    };

    const fetchSmsSenderIds = async () => {
        try {
            const payload = { Token: TOKEN, Details: { UserId: parseInt(DEFAULT_USER_ID, 10) } };
            const response = await fetch(SENDERID, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setSmsSenderIds(parsed);
                    if (parsed.length > 0) setSendSmsData(prev => ({ ...prev, SenderId: parsed[0].SenderName }));
                }
            }
        } catch (error) { console.error("Error fetching sender IDs:", error); }
    };

    const fetchSmsTemplates = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), isSMS: 1, isMail: 0 } };
            const response = await fetch(Template_for_main, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) setSmsTemplates(parsed);
            }
        } catch (error) { console.error("Error fetching SMS templates:", error); }
    };

    const handleSendMail = async () => {
        if (sendMailData.ChooseEmails.length === 0) { showAlert('error', 'Error', "Please select at least one email address"); return; }
        if (!sendMailData.Account || !sendMailData.From || !sendMailData.Subject) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                objSendEmail_BO: {
                    Email: sendMailData.ChooseEmails[0],
                    Email1: sendMailData.ChooseEmails[1] || "",
                    Email2: sendMailData.ChooseEmails[2] || "",
                    EntityType: "enquiry",
                    EnquiryLeadId: entity.enquiryId.toString(),
                    EmailType: sendMailData.MailMode,
                    Account: sendMailData.Account.toString(),
                    Subject: sendMailData.Subject,
                    Message: sendMailData.Body,
                    SenderName: "", // Optional
                    ReplyTo: sendMailData.ReplyTo,
                    Template: sendMailData.TemplateId.toString() || "0",
                    FromMailID: sendMailData.From
                },
                UserId: parseInt(DEFAULT_USER_ID, 10)
            };

            const response = await fetch(SEND_EMAIL_EXT, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            const isSuccess = response.ok && (
                result.d === "Success" ||
                result.Status === 1 ||
                (typeof result.d === 'string' && /success|succees/i.test(result.d))
            );

            if (isSuccess) {
                showOperationSuccess(typeof result.d === 'string' && /success|succees/i.test(result.d) ? result.d : "Email sent successfully");
            } else {
                showAlert('error', 'Error', result.d || result.Message || "Failed to send email");
            }
        } catch (error) {
            console.error("Error sending email:", error);
            showAlert('error', 'Error', "Network error while sending email");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSendSms = async () => {
        if (sendSmsData.ChooseNumbers.length === 0) { showAlert('error', 'Error', "Please select at least one mobile number"); return; }
        if (!sendSmsData.Account || !sendSmsData.SenderId || !sendSmsData.Message) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                objSendSms_BO: {
                    MobileNo: sendSmsData.ChooseNumbers[0],
                    MobileNo1: sendSmsData.ChooseNumbers[1] || "",
                    MobileNo2: sendSmsData.ChooseNumbers[2] || "",
                    EntityType: "enquiry",
                    EnquiryLeadId: entity.enquiryId.toString(),
                    SmsType: sendSmsData.SmsType.toLowerCase(),
                    Account: sendSmsData.Account.toString(),
                    SenderName: sendSmsData.SenderId,
                    SenderID: sendSmsData.SenderId,
                    Message: sendSmsData.Message,
                    IsUnicode: sendSmsData.IsUnicode,
                    Template: sendSmsData.TemplateId.toString() || "0"
                },
                ParentId: parseInt(SESSION_PARENT_ID, 10),
                UserId: parseInt(DEFAULT_USER_ID, 10)
            };

            const response = await fetch(SEND_SMS_EXT, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                showOperationSuccess("SMS sent successfully");
            } else {
                const result = await response.json();
                showAlert('error', 'Error', result.d || result.Message || "Failed to send SMS");
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
            showAlert('error', 'Error', "Network error while sending SMS");
        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchDniNumbers = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), AppId: 2, Opt: 0 } };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setDniNumbers(parsed);
                    if (parsed.length > 0) setSendVoiceData(prev => ({ ...prev, DnidNo: parsed[0].Code || parsed[0].Id }));
                }
            }
        } catch (error) { console.error("Error fetching DNI numbers:", error); }
    };

    const fetchAppFlows = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), AppId: 0, Opt: 2 } };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setAppFlows(parsed);
                    if (parsed.length > 0) setSendVoiceData(prev => ({ ...prev, AppFlow: parsed[0].Id || parsed[0].Text }));
                }
            }
        } catch (error) { console.error("Error fetching App Flows:", error); }
    };

    const handleSendVoice = async () => {
        const selectedNum = sendVoiceData.ChooseNumbers[0];
        if (!selectedNum) { showAlert('error', 'Error', "Please select at least one mobile number"); return; }
        if (!sendVoiceData.DnidNo || !sendVoiceData.AppFlow) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }
        setIsSubmitting(true);
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: parseInt(entity.enquiryId) || 0,
                    SendVoice: {
                        MobileNo: selectedNum.replace(/\D/g, '').slice(-10),
                        Route: sendVoiceData.Route === 'trans' ? "2" : "1",
                        AppFlow: sendVoiceData.AppFlow || "1",
                        DnidNo: sendVoiceData.DnidNo || "",
                        Duration: String(sendVoiceData.Duration || "30"),
                        Voice_Source: "CRM",
                        EntityName: "Enquiry",
                        EntityId: String(entity.enquiryId)
                    }
                }
            };
            const response = await fetch(add_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            const isSuccess = response.ok && (
                result.Status === 1 ||
                result.d?.Status === 1 ||
                (typeof result.d === 'string' && /success|succees/i.test(result.d))
            );

            if (isSuccess) {
                showOperationSuccess(typeof result.d === 'string' && /success|succees/i.test(result.d) ? result.d : "Voice Sent Successfully");
            } else {
                showAlert('error', 'Error', result.d || result.Message || result.Details || "Failed to initiate voice call");
            }
        } catch (error) {
            console.error("Error sending voice:", error);
            showAlert('error', 'Error', "Network error while sending voice call");
        } finally {
            setIsSubmitting(false);
        }
    };

    const checkWhatsAppRegistration = async () => {
        if (!entity.enquiryId) return;
        setIsCheckingWhatsapp(true);
        try {
            const response = await fetch(Is_Register_for_Whatsapp, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: "-2295521862261168",
                    Details: {
                        LeadId: parseInt(entity.enquiryId, 10),
                        EntityName: "enquiry"
                    }
                })
            });
            if (response.ok) {
                const result = await response.json();
                let isReg = false;
                let channelId = '';
                try {
                    const details = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                    if (details && details.ChannelProfileId) {
                        isReg = true;
                        channelId = details.ChannelProfileId;
                    } else {
                        isReg = result.Details === true || result.Details === "true";
                    }
                } catch (e) {
                    isReg = result.Details === true || result.Details === "true";
                }
                setWhatsappData(prev => ({ ...prev, IsRegistered: isReg, ChannelProfileId: channelId }));
                
                if (!isReg) {
                    fetchAssociateMobileNumbers();
                } else {
                    setShowAssociateView(false);
                }
            }
        } catch (error) {
            console.error("Error checking WhatsApp registration:", error);
        } finally {
            setIsCheckingWhatsapp(false);
        }
    };

    const fetchAssociateMobileNumbers = async () => {
        try {
            const payload = {
                Token: TOKEN.toString(),
                LoggedUserId: DEFAULT_USER_ID.toString(),
                Details: {
                    EntityId: entity.enquiryId.toString(),
                    EntityName: "enquiry"
                }
            };
            const response = await fetch(Get_Associate_Mobile_No, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                setAssociateMobileList(result.Details || []);
                if (result.Details && result.Details.length > 0) {
                    setShowAssociateView(true);
                }
            }
        } catch (error) {
            console.error("Error fetching associated mobile numbers:", error);
        }
    };

    const handleAssociate = async () => {
        if (!selectedAssociate) return;

        setAlertConfig({
            show: true,
            type: 'confirm',
            title: 'Confirm Association',
            message: 'This action will dissociate the WhatsApp no. from existing lead/enquiry and associate it with this entity. This action WILL NOT move the previous conversations go the new entity. They will be available in that entity itself?',
            confirmText: 'Continue',
            onConfirm: async () => {
                setAlertConfig(prev => ({ ...prev, show: false }));
                setIsAssociating(true);
                try {
                    const payload = {
                        Token: TOKEN.toString(),
                        LoggedUserId: DEFAULT_USER_ID.toString(),
                        Details: {
                            oldEntityName: selectedAssociate.EntityName,
                            oldEntityId: Number(selectedAssociate.EntityId),
                            EntityId: entity.enquiryId.toString(),
                            EntityName: "enquiry",
                            ChannelProfileId: selectedAssociate.ChannelProfileId,
                            ChannelName: "whatsapp",
                            profileJson: "{}",
                            UserId: DEFAULT_USER_ID.toString()
                        }
                    };
                    const response = await fetch(Get_Associate_Wrapper, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                    if (response.ok) {
                        const result = await response.json();
                        if (result.Status === 1) {
                            checkWhatsAppRegistration();
                            showOperationSuccess("Data saved successfully");
                        } else {
                            showAlert('error', 'Error', result.Message || "Failed to associate mobile number");
                        }
                    }
                } catch (error) {
                    console.error("Error associating mobile number:", error);
                    showAlert('error', 'Error', "Network error while associating mobile number");
                } finally {
                    setIsAssociating(false);
                }
            },
            onCancel: () => setAlertConfig(prev => ({ ...prev, show: false }))
        });
    };

    const fetchWhatsAppTemplates = async () => {
        try {
            const response = await fetch(Whatsapp_Template, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    Token: "-2295521862261168", 
                    Details: { UserId: parseInt(DEFAULT_USER_ID, 10), Mode: "approved" } 
                })
            });
            if (response.ok) {
                const result = await response.json();
                setWhatsappTemplates(Array.isArray(result) ? result : (result.Details || result.d || []));
            }
        } catch (error) {
            console.error("Error fetching WhatsApp templates:", error);
        }
    };

    const handleSendWhatsApp = async () => {
        if (!whatsappData.SelectedTemplate) { showAlert('error', 'Error', "Please select a template"); return; }
        setIsSubmitting(true);
        try {
            const username = localStorage.getItem('username') || 'kmukesh343';
            const mobileNo = availableNumbers[0] || '';
            const template = whatsappData.SelectedTemplate;
            const key = "dbcd909bcdc94576976cf0ce94b4ad54";

            const params = new URLSearchParams();
            params.append("key", key);
            params.append("username", username);
            params.append("name", "whatsapp");
            params.append("remarks", whatsappData.Message || "");
            params.append("whatsapp[to]", whatsappData.ChannelProfileId || mobileNo);
            params.append("whatsapp[type]", "template");
            params.append("whatsapp[category]", template.category || "MARKETING");
            params.append("whatsapp[recipient_type]", "individual");
            params.append("whatsapp[template][namespace]", "");
            params.append("whatsapp[template][language][policy]", "deterministic");
            params.append("whatsapp[template][language][code]", template.tlanguage || "en");
            params.append("whatsapp[template][name]", template.templatename);

            const response = await fetch(SEND_TEMPLATE, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params
            });

            if (response.ok) {
                const result = await response.json();
                showOperationSuccess(result?.meta?.developer_message || result?.developer_message || "Message submitted successfully");
            } else {
                const result = await response.json();
                showAlert('error', 'Error', result?.meta?.developer_message || result?.developer_message || "Failed to send WhatsApp message");
            }
        } catch (error) {
            console.error("Error sending WhatsApp:", error);
            showAlert('error', 'Error', "An error occurred while sending WhatsApp message");
        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchSalesActivityTypes = async () => {
        try {
            const res = await fetch(SALES_ACTIVITY_TYPE_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(DEFAULT_USER_ID, 10) } })
            });
            const data = await res.json();
            const result = data.d || data.Details || [];
            setSalesActivityOptions(Array.isArray(result) ? result : []);
        } catch (e) { console.error("Error fetching sales activity types:", e); }
    };

    const fetchCollaborators = async () => {
        try {
            const response = await fetch(USER_HIERARCHY_URL, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: DEFAULT_USER_ID } })
            });
            if (response.ok) {
                const result = await response.json();
                const rawData = result.Details?.data || result.Details || result.d || [];
                let parsed = Array.isArray(rawData) ? rawData : [];
                if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
                setCollaboratorOptions(Array.isArray(parsed) ? parsed : []);
            }
        } catch (error) { console.error("Error fetching collaborators:", error); }
    };

    const initGoogleMaps = () => {
        const scriptId = 'google-maps-script';
        const isGoogleMapsReady = () => window.google && window.google.maps && window.google.maps.places;
        if (isGoogleMapsReady()) { setScriptsLoaded(true); return; }
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAO-dLMQIXYLvJeig0dbjeEqytvPg6EMd8&libraries=places&loading=async&callback=initGoogleMapsCallback`;
            script.async = true; script.defer = true;
            window.initGoogleMapsCallback = () => setScriptsLoaded(true);
            script.onerror = () => console.error("Google Maps script failed to load");
            document.body.appendChild(script);
        } else {
            const checkInterval = setInterval(() => { if (isGoogleMapsReady()) { setScriptsLoaded(true); clearInterval(checkInterval); } }, 100);
            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    };

    const handleSaveAppointment = async () => {
        if (!appointmentData.Title.trim()) { showAlert('error', 'Error', "Please enter a title."); return; }
        const start = new Date(`${appointmentData.StartDate}T${appointmentData.StartTime}`);
        const end = new Date(`${appointmentData.EndDate}T${appointmentData.EndTime}`);
        if (start >= end) { showAlert('error', 'Error', "Start date must be smaller than end date"); return; }

        setIsSubmitting(true);
        try {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const formatForSave = (dateStr, timeStr) => {
                if (!dateStr || !timeStr) return "";
                const d = new Date(`${dateStr}T${timeStr}`);
                return `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:00`;
            };

            const payload = {
                Token: TOKEN,
                LoggedUserId: DEFAULT_USER_ID,
                Details: {
                    Mode: "PI",
                    PhysicalAppointmentId: 0,
                    Title: appointmentData.Title,
                    Description: appointmentData.Description,
                    Address: appointmentData.Where || "",
                    AssignedTo: parseInt(appointmentData.Owner),
                    CollaboratorList: Array.isArray(appointmentData.Collaborators) ? appointmentData.Collaborators.join('#') : (appointmentData.Collaborators || ""),
                    CompleteAddress: appointmentData.CompleteAddress || "",
                    CreatedBy: parseInt(DEFAULT_USER_ID),
                    EmailId: entity.Email || "",
                    EndDate: formatForSave(appointmentData.EndDate, appointmentData.EndTime),
                    EntityId: (entity.enquiryId || "").toString(),
                    EntityName: entity.PersonName || "",
                    EntityType: "enquiry",
                    FieldExecutiveList: DEFAULT_USER_ID.toString(),
                    GeoEntitySiteId: 0,
                    Latitude: parseFloat(appointmentData.Latitude || 20.593684),
                    Longitude: parseFloat(appointmentData.Longitude || 78.96288),
                    Mobile: entity.MobileNo || "",
                    SenderName: "",
                    StartDate: formatForSave(appointmentData.StartDate, appointmentData.StartTime),
                    TaskTypeId: appointmentData.ActivityType || "505",
                    gCalendarId: ""
                }
            };

            const res = await fetch(ADD_PHYSICAL_APPOINTMENT, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                const text = await res.text();
                let isSuccess = false;
                let msg = "Physical Appointment saved successfully!";
                try {
                    const result = JSON.parse(text);
                    isSuccess = result.Status === 1 || result.Status === "1" || result.d?.Status === 1 || result.IsInserted === true || result.d?.IsInserted === true || /success|succees|created|saved/i.test(result.Message || result.d || "");
                    if (result.Message && typeof result.Message === 'string') msg = result.Message;
                    else if (result.d && typeof result.d === 'string') msg = result.d;
                } catch (e) {
                    isSuccess = /success|succees|created|saved|true/i.test(text);
                }
                
                if (isSuccess) {
                    showOperationSuccess(msg);
                } else {
                    showAlert('error', 'Error', "Failed to save appointment.");
                }
            } else { showAlert('error', 'Error', "Server error while saving appointment."); }
        } catch (error) {
            console.error("Error saving appointment:", error);
            showAlert('error', 'Error', "Network error while saving appointment.");
        } finally { setIsSubmitting(false); }
    };

    const showOperationSuccess = (message) => {
        showAlert('success', 'Success', message, () => {
            if (onSuccess) onSuccess();
        });
    };

    const showAlert = (type, title, message, onConfirm = null) => {
        setAlertConfig({
            show: true,
            type,
            title,
            message,
            onConfirm: () => {
                setAlertConfig(prev => ({ ...prev, show: false }));
                if (onConfirm) onConfirm();
            }
        });
    };

    const fetchFollowupStatuses = async () => {
        try {
            const response = await fetch(FOLLOWUP_STATUS_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID) } })
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setFollowupStatusOptions(parsed);
                }
            }
        } catch (error) {
            console.error("Error fetching followup statuses:", error);
        }
    };

    const handleFollowupChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFollowupData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSaveFollowup = async () => {
        if (followupData.FollowupStatus === '' || followupData.FollowupStatus === undefined) {
            showAlert('error', 'Error', 'Please select a followup status');
            return;
        }

        const rawValue = followupData.FollowupStatus.toString();
        const valueParts = rawValue.split(',');
        const statusId = Number(valueParts[0]);

        // Use the second part of the comma-separated value (0 = negative, 1 = scheduled/positive)
        const isNegative = valueParts.length > 1 ? valueParts[1] === '0' : false;

        setIsSubmitting(true);
        try {
            const formattedNextDate = `${followupData.NextStatusDate} ${followupData.NextStatusTime}:00`;

            // ids can come from entity.enquiryId or selectedEnquiries
            const ids = entity.enquiryId || (Array.isArray(selectedEnquiries) ? selectedEnquiries.join(',') : '');

            const followupItem = {
                AssignTo: isNegative ? 0 : (Number(followupData.AssignTo) || Number(DEFAULT_USER_ID) || 0),
                FollowupStatus: statusId,
                NextStatusDate: isNegative ? "1900-01-01 00:00:00" : formattedNextDate,
                Products: isNegative ? "" : followupData.Products,
                AmountPaid: (isNegative || !followupData.AmountPaid) ? 0 : parseFloat(followupData.AmountPaid),
                Remarks: followupData.Remarks,
                IsReassign: isNegative ? 0 : (followupData.IsReassign ? 1 : 0)
            };

            const payload = {
                Token: TOKEN,
                Details: {
                    massAddFollowUps: [followupItem],
                    IDS: ids.toString(),
                    Userid: Number(DEFAULT_USER_ID),
                    ParentID: Number(SESSION_PARENT_ID || 1),
                    massbatchid: 0,
                    StartDateTime: followupData.OnSchedule ? followupData.ScheduleDateTime.replace('T', ' ') + ':00' : new Date().toISOString().replace('T', ' ').slice(0, 19)
                }
            };

            const response = await fetch(SAVE_MASS_FOLLOWUP, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 || result.Status === "1" || result.d?.Status === 1 || (typeof result.d === 'string' && /success|succees/i.test(result.d))) {
                    showOperationSuccess(typeof result.d === 'string' && /success|succees/i.test(result.d) ? result.d : "Lead generated successfully");
                } else {
                    showAlert('error', 'Error', result.Message || result.d || "Failed to add followup");
                }
            } else {
                showAlert('error', 'Error', "Server error while adding followup");
            }
        } catch (error) {
            console.error("Error saving followup:", error);
            showAlert('error', 'Error', "Network error while saving followup");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleChange = (e, setter) => {
        const { name, value, type, checked } = e.target;
        setter(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSendMailChange = (e) => handleChange(e, setSendMailData);
    const handleSendSmsChange = (e) => handleChange(e, setSendSmsData);
    const handleSendVoiceChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'ChooseNumbers') {
            setSendVoiceData(prev => ({ ...prev, ChooseNumbers: checked ? [value] : [] }));
        } else {
            setSendVoiceData(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleAppointmentChange = (e) => handleChange(e, setAppointmentData);

    const formatDateDisplay = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${d.getDate().toString().padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
    };

    const fetchTags = async () => {
        setIsLoading(true);
        try {
            const { userId } = getSession();
            const response = await fetch(TAG_LIST_FILTER, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { strFilter: "", strUserID: String(userId || DEFAULT_USER_ID) } })
            });
            if (response.ok) {
                const data = await response.json();
                setTags(data.d || []);
            }
        } catch (error) {
            console.error("Error fetching tags:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveTag = async () => {
        if (!selectedTag) return;
        setIsSubmitting(true);
        try {
            const formattedDate = isScheduled && scheduleDateTime
                ? scheduleDateTime.replace('T', ' ') + ':00'
                : new Date().toISOString().slice(0, 19).replace('T', ' ');

            const enquiryIds = entity.enquiryId || (Array.isArray(entity.selectedEnquiries) ? entity.selectedEnquiries.join(',') : '');

            const payload = {
                Token: TOKEN,
                Details: {
                    objMassTag: {
                        EnquiryIds: enquiryIds,
                        Tags: selectedTag,
                        ScheduledDateTime: formattedDate,
                        UserId: Number(DEFAULT_USER_ID),
                        BatchId: 0,
                        ...(currentMode === 'remove_tag' && { ActionType: "Remove Tag" })
                    }
                }
            };

            const response = await fetch(ADD_REMOVE_TAGS, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.Status === 1 || result.Status === "1") {
                setAlertConfig({
                    show: true,
                    type: 'success',
                    title: 'Success',
                    message: result.Message || `Tag ${currentMode === 'add_tag' ? 'added' : 'removed'} successfully!`,
                    onConfirm: () => {
                        setAlertConfig(prev => ({ ...prev, show: false }));
                        onSuccess && onSuccess();
                    }
                });
            } else {
                setAlertConfig({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: result.Message || 'Operation failed. Please try again.',
                    onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
                });
            }
        } catch (error) {
            console.error("Error saving tag:", error);
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Error',
                message: 'A network error occurred.',
                onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const getActionTitle = () => {
        switch (currentMode) {
            case 'mail': case 'send-mail': return 'Send Mail';
            case 'sms': case 'send-sms': return 'Send SMS';
            case 'voice': case 'send-voice': return 'Send Voice';
            case 'appointment': case 'add-appointment': return 'Add Physical Appointment';
            case 'whatsapp': case 'send-whatsapp': return 'Send WhatsApp';
            case 'add_tag': return 'Add Tag';
            case 'remove_tag': return 'Remove Tag';
            case 'followup': return 'Add Followup';
            default: return 'Action Operation';
        }
    };

    return (
        <div className="lead-action-operation-container">
            <div className="action-operation-panel">
                <div className="action-operation-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 className="action-title">{getActionTitle()}</h2>
                    <X size={20} style={{ cursor: 'pointer', color: '#64748b' }} onClick={onBack} />
                </div>
                <div className="action-operation-content">
                    {(currentMode === 'mail' || currentMode === 'send-mail') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Choose Target Emails</label>
                                        <div className="checkbox-list">
                                            {availableEmails.filter(isValidValue).length > 0 ? (
                                                availableEmails.filter(isValidValue).map(email => (
                                                    <label key={email} className="checkbox-item">
                                                        <input type="checkbox" checked={sendMailData.ChooseEmails.includes(email)} onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSendMailData(prev => ({ ...prev, ChooseEmails: checked ? [...prev.ChooseEmails, email] : prev.ChooseEmails.filter(e => e !== email) }));
                                                        }} />
                                                        {email}
                                                    </label>
                                                ))
                                            ) : (
                                                <div className="no-data-found-msg">Email id not found</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Mail Account <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Account" value={sendMailData.Account} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select Account--</option>
                                            {mailAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">From Address <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="From" value={sendMailData.From} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select From Address--</option>
                                            {fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Reply To <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="ReplyTo" value={sendMailData.ReplyTo} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select Reply To--</option>
                                            {fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Subject <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Subject" value={sendMailData.Subject} onChange={handleSendMailChange} className="action-input" placeholder="Email subject..." />
                                    </div>
                                    <div className="action-form-row">
                                        <div className="flex-row">
                                            <button className={`tab-btn ${sendMailData.MailMode === 'template' ? 'active' : ''}`} onClick={() => setSendMailData(prev => ({ ...prev, MailMode: 'template' }))}>Use Template</button>
                                            <button className={`tab-btn ${sendMailData.MailMode === 'compose' ? 'active' : ''}`} onClick={() => setSendMailData(prev => ({ ...prev, MailMode: 'compose' }))}>Compose</button>
                                        </div>
                                    </div>
                                    {sendMailData.MailMode === 'template' ? (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Template <span style={{ color: '#ef4444' }}>*</span></label>
                                            <select name="TemplateId" value={sendMailData.TemplateId} onChange={(e) => {
                                                const tid = e.target.value;
                                                setSendMailData(prev => ({ ...prev, TemplateId: tid }));
                                                if (tid) fetchMailSubject(tid);
                                            }} className="action-select">
                                                <option value="">--Select Template--</option>
                                                {mailTemplates.map((t, i) => <option key={i} value={t.MailTemplateId}>{t.MailTemplateName}</option>)}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Message Body</label>
                                            <textarea name="Body" value={sendMailData.Body} onChange={handleSendMailChange} className="action-textarea" style={{ height: '150px' }}></textarea>
                                        </div>
                                    )}
                                </div>
                                <div className="action-footer">
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button className="btn-save" onClick={handleSendMail} disabled={isSubmitting}>
                                        SEND MAIL
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'sms' || currentMode === 'send-sms') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Select Phone Numbers</label>
                                        <div className="checkbox-list">
                                            {availableNumbers.filter(isValidValue).length > 0 ? (
                                                availableNumbers.filter(isValidValue).map(num => (
                                                    <label key={num} className="checkbox-item">
                                                        <input type="checkbox" checked={sendSmsData.ChooseNumbers.includes(num)} onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSendSmsData(prev => ({ ...prev, ChooseNumbers: checked ? [...prev.ChooseNumbers, num] : prev.ChooseNumbers.filter(n => n !== num) }));
                                                        }} />
                                                        {num}
                                                    </label>
                                                ))
                                            ) : (
                                                <div className="no-data-found-msg">Mobile number not found</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Account <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Account" value={sendSmsData.Account} onChange={handleSendSmsChange} className="action-select">
                                            <option value="">--Select Account--</option>
                                            {smsAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Sender ID <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="SenderId" value={sendSmsData.SenderId} onChange={handleSendSmsChange} className="action-select">
                                            <option value="">--Select Sender ID--</option>
                                            {smsSenderIds.map((s, i) => <option key={i} value={s.SenderName}>{s.SenderName}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <div className="flex-row">
                                            <button className={`tab-btn ${sendSmsData.SmsType === 'template' ? 'active' : ''}`} onClick={() => setSendSmsData(prev => ({ ...prev, SmsType: 'template' }))}>Use Template</button>
                                            <button className={`tab-btn ${sendSmsData.SmsType === 'Compose' ? 'active' : ''}`} onClick={() => setSendSmsData(prev => ({ ...prev, SmsType: 'Compose' }))}>Compose</button>
                                        </div>
                                    </div>
                                    {sendSmsData.SmsType === 'template' && (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Template</label>
                                            <select name="TemplateId" value={sendSmsData.TemplateId} onChange={(e) => {
                                                const tid = e.target.value;
                                                const template = smsTemplates.find(t => t.MailTemplateId.toString() === tid);
                                                setSendSmsData(prev => ({
                                                    ...prev,
                                                    TemplateId: tid,
                                                    Message: template ? template.MailTemplateContent : prev.Message
                                                }));
                                            }} className="action-select">
                                                <option value="">--Select Template--</option>
                                                {smsTemplates.map((t, i) => <option key={i} value={t.MailTemplateId}>{t.MailTemplateName}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    <div className="action-form-row">
                                        <label className="action-form-label">Message <span style={{ color: '#ef4444' }}>*</span></label>
                                        <textarea name="Message" value={sendSmsData.Message} onChange={handleSendSmsChange} className="action-textarea" style={{ height: '150px' }}></textarea>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button className="btn-save" onClick={handleSendSms} disabled={isSubmitting}>
                                        SEND SMS
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'whatsapp' || currentMode === 'send-whatsapp') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                {showAssociateView && !whatsappData.IsRegistered ? (
                                    <div className="whatsapp-associate-section">
                                        <div className="associate-header" style={{ marginBottom: '16px', padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                            <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', margin: 0 }}>Entity Mobile Numbers</h3>
                                        </div>
                                        <div className="associate-table-wrapper" style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                                <thead>
                                                    <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
                                                        <th style={{ padding: '12px', fontWeight: '600', color: '#475569' }}>MobileNo</th>
                                                        <th style={{ padding: '12px', fontWeight: '600', color: '#475569', textAlign: 'right' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {associateMobileList.map((item, idx) => (
                                                        <tr key={idx} style={{ borderTop: '1px solid #e2e8f0' }}>
                                                            <td style={{ padding: '12px' }}>
                                                                <div style={{ fontWeight: '600', color: '#1e293b' }}>Mobile: {item.MobileNo}</div>
                                                                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>{item.Remarks}</div>
                                                            </td>
                                                            <td style={{ padding: '12px', textAlign: 'right' }}>
                                                                <input 
                                                                    type="radio" 
                                                                    name="associate_mobile" 
                                                                    checked={selectedAssociate?.ChannelProfileId === item.ChannelProfileId}
                                                                    onChange={() => setSelectedAssociate(item)}
                                                                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="action-footer" style={{ marginTop: '24px' }}>
                                            <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                            {selectedAssociate && (
                                                <button 
                                                    className="btn-save" 
                                                    onClick={handleAssociate} 
                                                    disabled={isAssociating}
                                                    style={{ background: 'transparent', color: '#3b82f6', border: 'none', fontWeight: '600', boxShadow: 'none' }}
                                                >
                                                    {isAssociating ? 'ASSOCIATING...' : 'Associate'}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="action-form-grid">
                                        {availableNumbers.filter(isValidValue).length > 0 ? (
                                            <>
                                                <div className="action-form-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <label className="section-label">Choose Template</label>
                                                    {!whatsappData.IsRegistered && (
                                                        <span style={{ fontSize: '11px', color: '#ef4444', background: '#fef2f2', padding: '2px 8px', borderRadius: '12px', border: '1px solid #fee2e2' }}>
                                                            Not Registered
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="whatsapp-templates-grid" style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                                                    gap: '12px',
                                                    maxHeight: '240px',
                                                    overflowY: 'auto',
                                                    padding: '4px'
                                                }}>
                                                    {whatsappTemplates.filter(t => t.templatetype !== 'MediaIntractive').map((t) => (
                                                        <div
                                                            key={t.id}
                                                            className={`whatsapp-template-card ${whatsappData.TemplateId == t.id ? 'active' : ''}`}
                                                            onClick={() => {
                                                                const json = t.kit19TemplateJSON ? JSON.parse(t.kit19TemplateJSON) : null;
                                                                let message = json ? (json.components?.find(c => c.type === 'BODY')?.text || '') : '';
                                                                
                                                                // Dynamic placeholder replacement
                                                                const mappings = {
                                                                    '[#PersonName#]': entity.PersonName || '',
                                                                    '[#MobileNo#]': entity.MobileNo || entity.MobileNo3 || '',
                                                                    '[#EmailId#]': entity.Email || entity.EmailID || '',
                                                                    '[#EnquiryId#]': (entity.EnquiryId || entity.enquiryId || '').toString()
                                                                };
                                                                
                                                                Object.keys(mappings).forEach(key => {
                                                                    message = message.replaceAll(key, mappings[key]);
                                                                });

                                                                setWhatsappData(prev => ({
                                                                    ...prev,
                                                                    TemplateId: t.id,
                                                                    SelectedTemplate: t,
                                                                    Message: message
                                                                }));
                                                            }}
                                                            style={{
                                                                padding: '12px',
                                                                border: `1.5px solid ${whatsappData.TemplateId == t.id ? '#22c55e' : '#e2e8f0'}`,
                                                                borderRadius: '8px',
                                                                cursor: 'pointer',
                                                                backgroundColor: whatsappData.TemplateId == t.id ? '#f0fdf4' : '#fff',
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                        >
                                                            <div style={{ fontSize: '12px', fontWeight: '600', color: whatsappData.TemplateId == t.id ? '#166534' : '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {t.templatename}
                                                            </div>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
                                                                <span style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b' }}>{t.category}</span>
                                                                <span style={{ fontSize: '9px', color: '#94a3b8' }}>{t.tlanguage}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {whatsappData.SelectedTemplate && (
                                                    <div className="whatsapp-preview-section" style={{ marginTop: '16px', backgroundColor: '#efeae2', borderRadius: '12px', padding: '16px', backgroundImage: 'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")', backgroundSize: 'contain' }}>
                                                        <div style={{ backgroundColor: '#fff', borderRadius: '8px 8px 8px 0', padding: '10px', maxWidth: '85%', boxShadow: '0 1px 0.5px rgba(0,0,0,0.13)', marginLeft: '4px' }}>
                                                            <div style={{ fontSize: '13px', color: '#111b21', whiteSpace: 'pre-wrap', lineHeight: '1.5', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>{whatsappData.Message}</div>
                                                            <div style={{ fontSize: '10px', color: '#667781', textAlign: 'right', marginTop: '4px' }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className="no-data-found-msg" style={{ padding: '24px', textAlign: 'center', background: '#f8fafc', borderRadius: '12px', border: '1px dashed #e2e8f0', color: '#64748b', gridColumn: 'span 2' }}>
                                                <div style={{ marginBottom: '8px' }}><Phone size={24} style={{ opacity: 0.5, margin: '0 auto' }} /></div>
                                                Mobile number not found
                                            </div>
                                        )}
                                        <div className="action-footer" style={{ marginTop: '20px' }}>
                                            <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                            <button className="btn-save" onClick={handleSendWhatsApp} disabled={isSubmitting || !whatsappData.SelectedTemplate} style={{ backgroundColor: '#22c55e' }}>
                                                {isSubmitting ? 'SENDING...' : 'SEND WHATSAPP'}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {(currentMode === 'voice' || currentMode === 'send-voice') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Select Caller Number</label>
                                        <div className="checkbox-list">
                                            {availableNumbers.filter(isValidValue).length > 0 ? (
                                                availableNumbers.filter(isValidValue).map(num => (
                                                    <label key={num} className="checkbox-item">
                                                        <input type="radio" name="ChooseNumbers" value={num} checked={sendVoiceData.ChooseNumbers.includes(num)} onChange={handleSendVoiceChange} />
                                                        {num}
                                                    </label>
                                                ))
                                            ) : (
                                                <div className="no-data-found-msg">Mobile number not found</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Caller ID (DNI) <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="DnidNo" value={sendVoiceData.DnidNo} onChange={handleSendVoiceChange} className="action-select">
                                            <option value="">--Select DNI--</option>
                                            {dniNumbers.map((d, i) => <option key={i} value={d.Code || d.Id}>{d.Code || d.Text || d.DniNo}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">App Flow <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="AppFlow" value={sendVoiceData.AppFlow} onChange={handleSendVoiceChange} className="action-select">
                                            <option value="">--Select Flow--</option>
                                            {appFlows.map((a, i) => <option key={i} value={a.Id || a.AppId}>{a.Text || a.AppFlowName}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Duration (Seconds)</label>
                                        <input type="number" name="Duration" value={sendVoiceData.Duration} onChange={handleSendVoiceChange} className="action-input" />
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button className="btn-save" onClick={handleSendVoice} disabled={isSubmitting}>
                                        SEND VOICE CALL
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'appointment' || currentMode === 'add-appointment') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Appointment Type <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="ActivityType" value={appointmentData.ActivityType} onChange={handleAppointmentChange} className="action-select">
                                            <option value="">--Select Type--</option>
                                            {salesActivityOptions.map((opt, i) => (
                                                <option key={i} value={opt.TasKId || opt.TaskId || opt.Value || opt.Id}>
                                                    {opt.TasKName || opt.TaskName || opt.Text || opt.Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Appointment Title <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Title" value={appointmentData.Title} onChange={handleAppointmentChange} className="action-input" placeholder="Enter appointment title" />
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Description</label>
                                        <textarea name="Description" value={appointmentData.Description} onChange={handleAppointmentChange} className="action-textarea" placeholder="Start Typing the details about the appointment" style={{ height: '80px' }}></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Remarks</label>
                                        <textarea name="Remarks" value={appointmentData.Remarks || ''} onChange={handleAppointmentChange} className="action-textarea" placeholder="Add any additional remarks..." style={{ height: '60px' }}></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>From Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="datetime-local" value={`${appointmentData.StartDate}T${appointmentData.StartTime}`}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val) setAppointmentData(prev => ({ ...prev, StartDate: val.split('T')[0], StartTime: val.split('T')[1] }));
                                            }} className="action-input" />
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Due Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="datetime-local" value={`${appointmentData.EndDate}T${appointmentData.EndTime}`}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val) setAppointmentData(prev => ({ ...prev, EndDate: val.split('T')[0], EndTime: val.split('T')[1] }));
                                            }} className="action-input" />
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Where <span style={{ color: '#ef4444' }}>*</span></label>
                                        <div style={{ position: 'relative' }}>
                                            <Search size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', zIndex: 1 }} />
                                            <input ref={whereInputRef} type="text" name="Where" value={appointmentData.Where} onChange={handleAppointmentChange} className="action-input search-location-input" style={{ paddingLeft: '44px' }} placeholder="Search location..." />
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Complete Address</label>
                                        <textarea name="CompleteAddress" value={appointmentData.CompleteAddress || ''} onChange={handleAppointmentChange} className="action-textarea" placeholder="Please enter complete address." style={{ height: '60px' }}></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginBottom: '6px', display: 'block' }}>Owner <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Owner" value={appointmentData.Owner} onChange={handleAppointmentChange} className="action-select">
                                            <option value="">--Select Owner--</option>
                                            {collaboratorOptions.map((opt, i) => (
                                                <option key={i} value={opt.Id || opt.Code || opt.Value || opt.UserId}>
                                                    {opt.Text || opt.Name || opt.UserName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button className="btn-save" onClick={handleSaveAppointment} disabled={isSubmitting}>
                                        SAVE APPOINTMENT
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'add_tag' || currentMode === 'remove_tag') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Select Tag <span style={{ color: '#ef4444' }}>*</span></label>
                                        {!isCustomTag ? (
                                            <select
                                                className="action-select"
                                                value={selectedTag}
                                                onChange={(e) => {
                                                    if (e.target.value === '___CUSTOM___') {
                                                        setIsCustomTag(true);
                                                        setSelectedTag('');
                                                    } else {
                                                        setSelectedTag(e.target.value);
                                                    }
                                                }}
                                            >
                                                <option value="">--Select Tag--</option>
                                                {tags.map((tag, idx) => (
                                                    <option key={idx} value={tag.TagWithID}>{tag.TagWithID}</option>
                                                ))}
                                                <option value="___CUSTOM___">+ Add New Tag...</option>
                                            </select>
                                        ) : (
                                            <div className="flex gap-2">
                                                <input
                                                    type="text"
                                                    className="action-input"
                                                    placeholder="Enter new tag name"
                                                    value={selectedTag}
                                                    onChange={(e) => setSelectedTag(e.target.value)}
                                                    autoFocus
                                                />
                                                <button
                                                    type="button"
                                                    className="btn-cancel"
                                                    onClick={() => {
                                                        setIsCustomTag(false);
                                                        setSelectedTag('');
                                                    }}
                                                    title="Back to list"
                                                    style={{ padding: '10px' }}
                                                >
                                                    <ArrowLeft size={16} />
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    <div className="action-form-row">
                                        <label className="checkbox-item" style={{ marginTop: '10px' }}>
                                            <input
                                                type="checkbox"
                                                checked={isScheduled}
                                                onChange={(e) => {
                                                    setIsScheduled(e.target.checked);
                                                    if (e.target.checked && !scheduleDateTime) {
                                                        const now = new Date();
                                                        const offset = now.getTimezoneOffset() * 60000;
                                                        const localISOTime = new Date(now - offset).toISOString().slice(0, 16);
                                                        setScheduleDateTime(localISOTime);
                                                    }
                                                }}
                                            />
                                            On Schedule Date And Time
                                        </label>
                                    </div>

                                    {isScheduled && (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Schedule Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                            <div className="custom-date-picker" style={{
                                                position: 'relative',
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#f8fafc',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                cursor: 'pointer'
                                            }}>
                                                <Calendar size={18} style={{ color: '#64748b', marginRight: '10px' }} />
                                                <input
                                                    type="datetime-local"
                                                    value={scheduleDateTime}
                                                    onChange={(e) => setScheduleDateTime(e.target.value)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        opacity: 0,
                                                        cursor: 'pointer',
                                                        zIndex: 2
                                                    }}
                                                />
                                                <span style={{ fontSize: '13px', fontWeight: '500', color: '#1e293b' }}>
                                                    {formatDateDisplay(scheduleDateTime) || formatDateDisplay(new Date())}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="action-footer" style={{ marginTop: '20px' }}>
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button
                                        className="btn-save"
                                        onClick={handleSaveTag}
                                        disabled={isSubmitting || !selectedTag}
                                    >
                                        {isSubmitting ? 'SAVING...' : (currentMode === 'add_tag' ? 'ADD TAG' : 'REMOVE TAG')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {(currentMode === 'followup') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                {(() => {
                                    const rawStatusValue = followupData.FollowupStatus.toString();
                                    const isPositive = rawStatusValue.split(',')[1] === '1';

                                    return (
                                        <div className="action-form-grid">
                                            <div className="action-form-row">
                                                <label className="action-form-label">Follow up Status <span style={{ color: '#ef4444' }}>*</span></label>
                                                <select
                                                    name="FollowupStatus"
                                                    value={followupData.FollowupStatus}
                                                    onChange={handleFollowupChange}
                                                    className="action-select"
                                                >
                                                    <option value="">--Select Status--</option>
                                                    {followupStatusOptions.map((opt, idx) => (
                                                        <option key={idx} value={opt.Value || `${opt.Id},1` || opt.Text}>{opt.Text || opt.Name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {isPositive && (
                                                <>
                                                    <div className="action-form-row">
                                                        <label className="action-form-label">Assign To</label>
                                                        <select
                                                            name="AssignTo"
                                                            value={followupData.AssignTo}
                                                            onChange={handleFollowupChange}
                                                            className="action-select"
                                                        >
                                                            {collaboratorOptions.map((opt) => (
                                                                <option key={opt.Id || opt.Code} value={opt.Id || opt.Code}>{opt.Text || opt.Name || opt.UserName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="action-form-row">
                                                        <label className="action-form-label">Next Status Date</label>
                                                        <div className="custom-date-picker">
                                                            <Calendar size={18} className="calendar-icon" />
                                                            <input
                                                                type="date"
                                                                name="NextStatusDate"
                                                                value={followupData.NextStatusDate}
                                                                min={new Date().toISOString().split('T')[0]}
                                                                onChange={handleFollowupChange}
                                                                className="hidden-date-input"
                                                            />
                                                            <span className="date-display-text">
                                                                {followupData.NextStatusDate ? new Date(followupData.NextStatusDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-') : 'dd-mm-yyyy'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="action-form-row">
                                                        <label className="action-form-label">Next Status Time</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="time"
                                                                name="NextStatusTime"
                                                                value={followupData.NextStatusTime}
                                                                onChange={handleFollowupChange}
                                                                className="action-input"
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="action-form-row" style={{ gridColumn: 'span 2' }}>
                                                <label className="action-form-label">Remarks</label>
                                             
                                                <textarea
                                                    name="Remarks"
                                                    value={followupData.Remarks}
                                                    onChange={handleFollowupChange}
                                                    className="action-textarea"
                                                    placeholder="Enter remarks..."
                                                    style={{ height: '80px' }}
                                                ></textarea>
                                            </div>

                                            {isPositive && (
                                                <div className="action-form-row relative" style={{ gridColumn: 'span 2', zIndex: 50 }}>
                                                    <label className="action-form-label">Products</label>
                                                    <input
                                                        type="text"
                                                        name="Products"
                                                        value={productSearchTerm}
                                                        onChange={(e) => {
                                                            setProductSearchTerm(e.target.value);
                                                            // Only update the input search term, don't overwrite followupData.Products here
                                                        }}
                                                        onFocus={() => { if (suggestedProducts.length > 0) setShowProductDropdown(true); }}
                                                        className="action-input"
                                                        placeholder="Search and select products..."
                                                        autoComplete="off"
                                                    />
                                                    <div className="flex flex-wrap gap-2 mt-2">
                                                        {followupData.Products && followupData.Products.split(',').map(p => p.trim()).filter(Boolean).map((productName, idx) => (
                                                            <div key={idx} className="flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full border border-blue-100">
                                                                {productName}
                                                                <X size={12} className="cursor-pointer hover:text-blue-900" onClick={() => handleRemoveProduct(productName)} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {showProductDropdown && suggestedProducts.length > 0 && (
                                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                                            {suggestedProducts.map((p) => (
                                                                <div
                                                                    key={p.Id}
                                                                    className="flex items-center gap-3 p-2 hover:bg-gray-100 cursor-pointer border-b border-gray-50 last:border-0"
                                                                    onClick={() => handleSelectProduct(p)}
                                                                >
                                                                    <img
                                                                        src={p.Image || 'https://via.placeholder.com/40?text=No+Img'}
                                                                        alt={p.Name}
                                                                        className="w-10 h-10 object-cover rounded shadow-sm border border-gray-100"
                                                                        onError={(e) => { e.target.src = 'https://via.placeholder.com/40?text=No+Img'; e.target.onerror = null; }}
                                                                    />
                                                                    <div className="flex flex-col">
                                                                        <span className="text-sm font-medium text-gray-900">{p.Name}</span>
                                                                        <span className="text-xs text-gray-500">Price: {p.Price}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            <div className="action-form-row" style={{ gridColumn: 'span 2' }}>
                                                <div className="flex flex-col gap-4">
                                                    <label className="checkbox-item flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            name="IsReassign"
                                                            checked={followupData.IsReassign}
                                                            onChange={handleFollowupChange}
                                                            className="w-4 h-4"
                                                        />
                                                        <span className="text-sm font-semibold text-gray-700">Re-Assign</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()}
                                <div className="action-footer">
                                    <button className="btn-cancel" onClick={onBack}>Cancel</button>
                                    <button className="btn-save" onClick={handleSaveFollowup} disabled={isSubmitting || !followupData.FollowupStatus}>
                                        {isSubmitting ? 'SAVING...' : 'SAVE FOLLOWUP'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {alertConfig.show && (
                <Alert
                    show={true}
                    type={alertConfig.type}
                    title={alertConfig.title}
                    message={alertConfig.message}
                    confirmText={alertConfig.confirmText || 'OK'}
                    onConfirm={alertConfig.onConfirm}
                    onCancel={alertConfig.onCancel}
                    onClose={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                />
            )}
        </div>
    );
};

export default EnquiryActionOperation;
